// components
import VisibleLoading from '@/components/utilities/VisibleLoading';
import AnimatedNumber from '@/components/utilities/AnimatedNumber';

const ClaimWithNumber = ({ text, number }) => {
  return (
    <div className="my-24">
      <h2>
        <div className="mx-auto max-w-72 text-center lg:flex lg:max-w-full lg:flex-wrap lg:items-end lg:justify-between lg:text-left">
          <VisibleLoading delay={200}>
            {({ ref, className }) => {
              const index = text.indexOf('\n');

              return (
                <>
                  <span ref={ref} className={`basis-full ${className}`}>
                    {text.substring(0, index)}
                  </span>
                  <span className={className}>{text.substring(index)}</span>
                </>
              );
            }}
          </VisibleLoading>

          <VisibleLoading delay={700}>
            {({ ref, isVisible }) => (
              <>
                <span ref={ref} className="hidden flex-1 px-4 lg:inline">
                  <span
                    className={`bg-brand-400 inline-block h-[3px] w-full origin-bottom-left transition delay-300 duration-[1500ms] ${isVisible ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}
                  />
                </span>
              </>
            )}
          </VisibleLoading>

          <VisibleLoading delay={700}>
            {({ ref, className, isVisible }) => (
              <span
                ref={ref}
                className={`text-brand-400 inline-block min-w-[80px] pl-2 text-right lg:min-w-[150px] xl:pl-0 ${className}`}
              >
                <AnimatedNumber value={number} isVisible={isVisible} delay={700} /> %
              </span>
            )}
          </VisibleLoading>
        </div>
      </h2>
    </div>
  );
};
export default ClaimWithNumber;
